import React, { useState } from "react"
import Modali, { useModali } from "modali"
import TextInput from "./ui/TextInput"
import Button from "./ui/Button"
import Form from "./ui/Form"
import { toast } from "react-toastify"
import api from "../core/sdk/networkInterface"
import ReCAPTCHA from "react-google-recaptcha"
import CalendlyModal from "./CalendlyModal"

import { FaCheckCircle } from "react-icons/fa"
const ContactUsModal = ({ children }) => {
  const [completeModal, toggleCompleteModal] = useModali({
    animated: true,
    closeButton: true,
  })
  var ReCAPTCHA_API_KEY = "6LeYeecUAAAAAO2wf6ihL7vtJp_XLzrxDVcbGDPH"
  // form inputs
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [company, setCompany] = useState("")
  const [inquiry, setInquiry] = useState("")
  // form state
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [recaptchaCheck, setRecaptchaCheck] = useState(false)
  function submit() {
    setSubmitting(true)

    api
      .post("/account/send_inquiry/", {
        email,
        name,
        company,
        inquiry,
      })
      .then(response => {
        // toast.success(response.success, { autoClose: 5000 })
        setEmail("")
        setName("")
        setCompany("")
        setInquiry("")
        setSubmitted(true)
      })
      .catch(() => {
        toast.error("There was an issue with your request")
      })
      .finally(() => {
        setSubmitting(false)
      })
  }
  function onChange(value) {
    if (value.length > 0) {
      setRecaptchaCheck(true)
    } else {
      setRecaptchaCheck(false)
    }
  }
  return (
    <div>
      <div
        onClick={() => {
          toggleCompleteModal()
        }}
      >
        {children}
      </div>

      <Modali.Modal {...completeModal}>
        <div style={{ maxHeight: "650px" }}>
          <h1 className="text-2xl text-center mb-8">How can we help you? </h1>
          <div className="max-w-sm m-auto pb-16">
            {!submitted ? (
              <Form>
                <TextInput
                  id="name"
                  label="Name"
                  placeholder="Your Name"
                  name="name"
                  required
                  disabled={submitting}
                  value={name}
                  onChange={ev => setName(ev.target.value)}
                />
                <TextInput
                  id="company"
                  label="Company"
                  placeholder="Your Company Name"
                  name="company"
                  type="email"
                  disabled={submitting}
                  value={company}
                  onChange={ev => setCompany(ev.target.value)}
                />
                <TextInput
                  id="email"
                  label="Email"
                  placeholder="Your Email"
                  name="email"
                  type="email"
                  required
                  disabled={submitting}
                  value={email}
                  onChange={ev => setEmail(ev.target.value)}
                />
                <TextInput
                  id="inquiry"
                  label="Message"
                  placeholder="Tell us about what you're looking for and we'll get back to you!"
                  name="inquiry"
                  required
                  multiline
                  rows={4}
                  disabled={submitting}
                  value={inquiry}
                  onChange={ev => setInquiry(ev.target.value)}
                />
                <div className="flex flex-col text-center items-center">
                  <ReCAPTCHA sitekey={ReCAPTCHA_API_KEY} onChange={onChange} />
                  <Button
                    className="w-full mt-3"
                    primary
                    disabled={submitting || !recaptchaCheck}
                    onClick={submit}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            ) : (
              <div className="text-center py-2">
                <FaCheckCircle
                  className="text-2xl inline mb-1"
                  color={"green"}
                />
                &nbsp; Your enquiry has been successfully submitted. Thank you.
                <div>
                  If you'd like, you can also
                  <CalendlyModal>
                    <span
                      style={{ fontWeight: "bold", color: "#00a2ff" }}
                      className="cursor-pointer link"
                    >
                      Schedule a Demo
                    </span>
                  </CalendlyModal>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modali.Modal>
    </div>
  )
}

export default ContactUsModal
